export const hifi = {
  madridhifi_invoice_not_associated_deliverynote: `La factura no está asociada a ninguna nota de entrega.`,
  madridhifi_item_not_associated_deliverynoteitems: `El artículo {{0}} no está asociado a ningún ítem de la nota de entrega.`,
  madridhifi_item_amount_missmatch: `El importe del artículo #{{0}} ({{1}}) no coincide con el importe del ítem de la nota de entrega (Precio × Cantidad) {{2}}.`,
  madridhifi_invoice_amount_unmatch_deliverynote_amount: `El importe total de la factura '{{0}}' no coincide con el importe total del albarán '{{1}}'.`,
};
